import Link from 'next/link';
import { useMemo } from 'react';
import { Col, ListGroup, Row } from 'react-bootstrap';
import Avatar from '../directoryTheme/Avatar';
import { Notification } from './Notifications';
import composeNotificationActorsPictureObject from './utils/composeNotificationActorsPictureObject';
import composeOutgoingNotificationMessageForGroup from './utils/composeOutgoingNotificationMessageForBatch';

type Props = {
  notifications: Notification[];
};

export default function IndividualNotification({ notifications }: Props) {
  const notificationMessage = useMemo(
    () => composeOutgoingNotificationMessageForGroup(notifications),
    [notifications],
  );

  const notificationImages = useMemo(
    () => composeNotificationActorsPictureObject(notifications),
    [notifications],
  );

  return (
    <Link href={notificationMessage.url} passHref legacyBehavior>
      <ListGroup.Item
        as="a"
        action
        className="p-4 d-flex justify-content-between align-items-start"
        eventKey={notifications[0].id}
      >
        <Row>
          {notificationImages.length > 0 && (
            <Col xs="auto" className="align-self-center mb-4 mb-lg-0">
              {notificationImages.map((image) => (
                <Avatar
                  size="xs"
                  key={image?.picture?.id ?? image?.defaultText}
                  image={image?.picture?.file?.key}
                  defaultImageText={image?.defaultText}
                  alt={image?.defaultText}
                />
              ))}
            </Col>
          )}
          <Col className="align-self-center mb-4 mb-lg-0">
            <div className="ms-2 me-auto">{notificationMessage.message}</div>
          </Col>
        </Row>
      </ListGroup.Item>
    </Link>
  );
}
